export { EditHomepageV2Resource as default } from './resources';
